(function LoginAs($, Adzuki)
{
	"use strict";

	var _init;

	_init = function _init()
	{
		$('.login-as').click(function loginAs(e) {
			var $modal         = $('.modal'),
			    $link          = $(this),
			    message        = 'Click the link below to login as the selected agent.',
			    text           = 'Login as agent',
			    login_link_uri = '/Agents/getLoginAsModal/' + $link.data('agent-id'),
			    timer_timeout;

			if (typeof $link.data('message') !== 'undefined') {
				message = $link.data('message');
			}

			if (typeof $link.data('text') !== 'undefined') {
				text = $link.data('text');
			}

			if (typeof $link.data('app') !== 'undefined') {
				login_link_uri += '/' + $link.data('app');

				if (typeof $link.data('uri') !== 'undefined') {
					login_link_uri += '/' + encodeURIComponent($link.data('uri'));
				}
			}

			e.preventDefault();

			$modal.find('.modal-dialog').addClass('login-as');
			$modal.find('.modal-title').text('Login as Agent');
			$modal.find('.modal-body').html('Retrieving "Login as" link...');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				clearTimeout(timer_timeout);

				$modal.find('.modal-dialog').removeClass('login-as');
				$modal.off('hidden.bs.modal');
			});

			$modal.modal('show');

			Adzuki.Ajax.get(login_link_uri).then(function success(response) {
				var timer,
				    time_remaining = 20;

				$modal.find('.modal-body').html(response);

				if ($modal.find('.login-as-message').length > 0) {
					$modal.find('.login-as-message').html(message);
				}

				$modal.find('.login-as-text').html(text);

				$modal.find('.login-as-incognito').click(function loginAs(e) {
					e.preventDefault();

					Adzuki.StatusMessage('Error', 'Please right-click and choose "Open link in incognito window"', 'Use Incognito Window');
				});

				timer = function timer() {
					var text = time_remaining + ' second' + ((time_remaining === 1) ? '' : 's');

					$modal.find('.login-as-time').html(text);

					if (time_remaining === 0) {
						$modal.modal('hide');

						return;
					}

					time_remaining--;

					timer_timeout = setTimeout(timer, 1000);
				};

				timer();
			});
		});
	};

	$(document).ready(function documentReady()
	{
		_init();
	});
}(jQuery, window.Adzuki || {}));
